import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../api/api-context';
import { z } from 'zod';
import isBase64 from 'validator/lib/isBase64';
export const simpleFinRequestSchema = z.object({
    token: z.string().refine((val) => isBase64(val), {
        message: 'Invalid base64 token',
    }),
});
export const useSimpleFinLinkApi = (mutationConfig) => {
    const api = useApi();
    const queryClient = useQueryClient();
    const { onSuccess, onError, ...restConfig } = mutationConfig || {};
    const simpleFinLinkApi = async (data) => {
        await api.post('/simple-fin/link', data);
    };
    return useMutation({
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ['subscription'] }).then(() => { });
            queryClient.invalidateQueries({ queryKey: ['external-accounts'] }).then(() => { });
            onSuccess?.(...args);
        },
        onError,
        ...restConfig,
        mutationFn: simpleFinLinkApi,
    });
};
